import React from "react";
import { useQuery } from "@tanstack/react-query";
import { fetchers } from "../lib/api";

const Chip = ({ active, onClick, children, testId }) => (
  <button
    data-testid={testId}
    onClick={onClick}
    className={`shrink-0 border px-3 py-1.5 overline-eyebrow transition-colors ${
      active
        ? "border-primary bg-primary text-primary-foreground"
        : "border-border bg-card text-foreground hover:border-primary hover:text-primary"
    }`}
  >
    {children}
  </button>
);

export const LeagueTabs = ({ value, onChange, includeAll = false }) => {
  const { data: leagues = [] } = useQuery({ queryKey: ["leagues"], queryFn: fetchers.leagues, staleTime: Infinity });
  return (
    <div className="-mx-4 overflow-x-auto px-4 pb-1 sm:mx-0 sm:px-0" data-testid="league-tabs">
      <div className="flex w-max gap-2">
        {includeAll && (
          <Chip active={value === "all"} onClick={() => onChange("all")} testId="league-tab-all">
            All Leagues
          </Chip>
        )}
        {leagues.map((l) => (
          <Chip key={l.slug} active={value === l.slug} onClick={() => onChange(l.slug)} testId={`league-tab-${l.slug}`}>
            {l.name}
          </Chip>
        ))}
      </div>
    </div>
  );
};

export default LeagueTabs;
